import script from "./BarChartCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BarChartCard.vue?vue&type=script&setup=true&lang=ts"

import "./BarChartCard.vue?vue&type=style&index=0&id=fba3cbd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fba3cbd4"]])

export default __exports__